export default __webpack_public_path__ + "static/media/btc_logo.79245397.svg";